export const partners = [
    {
        name: "Intra Lighting",
        image: "./assets/partners/intra.png",
        url: "https://it.intra-lighting.com/",
        descriptionKey: "partnerIntraDesc"
    },
    {
        name: "Cariboni Group",
        image: "./assets/partners/cariboni.png",
        url: "https://www.caribonigroup.com/it",
        descriptionKey: "partnerCariboniDesc"
    },
    {
        name: "Ridi Italia",
        image: "./assets/partners/ridi.png",
        url: "https://www.ridi.de/it/",
        descriptionKey: "partnerRidiDesc"
    },
    {
        name: "Wieland Electric",
        image: "./assets/partners/wieland.png",
        url: "https://www.wieland-electric.it/it/",
        descriptionKey: "partnerWielandDesc"
    },
    {
        name: "Leitner Energy",
        image: "./assets/partners/leitner.png",
        url: "https://www.leitnerenergy.it/",
        descriptionKey: "partnerLeitnerDesc"
    },
    {
        name: "Volatiles",
        image: "./assets/partners/volatiles.png",
        url: "https://volatiles.lighting/",
        descriptionKey: "partnerVolatilesDesc"
    }
];